import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Desafios_Cursos } from 'generated/graphql';

const initialState: Desafios_Cursos | any = null;

const currentDesafioSelectedEstudianteSlice = createSlice({
	name: 'currentDesafioSelectedEstudiante',
	initialState,
	reducers: {
		setCurrentDesafioSelectedEstudiante: (state, action: PayloadAction<Desafios_Cursos | any>) => {
			return action.payload;
		},
		updateCurrentDesafioSelectedEstudiante: (state, action: PayloadAction<Desafios_Cursos | any>) => {
			return action.payload || state;
		},
		resetCurrentDesafioSelectedEstudiante: () => {
			return initialState;
		},
		addGuiaEnviada: (state, action: PayloadAction<any>) => {
			if (!state) return state;
			return {
				...state,
				guia_digital_enviadas: [...(state?.guia_digital_enviadas || []), action.payload]
			};
		},
		addGuiaEnviadaGrupo: (state, action: PayloadAction<any>) => {
			if (!state) return state;

			const updatedGrupos = state?.desafios_cursos_estudiantes_grupos?.map((dceg: any) => {
				if (dceg?.grupo?.key === action.payload?.grupo_key) {
					return {
						...dceg,
						grupo: {
							...dceg?.grupo,
							guia_digital_enviadas: [
								...(dceg?.grupo?.guia_digital_enviadas || []),
								action.payload?.guia_digital
							]
						}
					};
				}
				return dceg;
			});
			const newState = {
				...state,
				desafios_cursos_estudiantes_grupos: updatedGrupos
			};
			return newState;
		},
		addInstrumentoEnviadoIndividual: (state, action: PayloadAction<any>) => {
			if (!state) return state;
			return {
				...state,
				actividades_rubricas_enviadas: [...(state?.actividades_rubricas_enviadas || []), action.payload]
			};
		},
		addInstrumentoEnviadoGrupal: (state, action: PayloadAction<any>) => {
			if (!state) return state;

			const updatedGrupos = state?.desafios_cursos_estudiantes_grupos?.map((dceg: any) => {
				if (dceg?.grupo?.key === action.payload?.grupo_key) {
					return {
						...dceg,
						grupo: {
							...dceg?.grupo,
							actividades_rubricas_enviadas: [
								...(dceg?.grupo?.actividades_rubricas_enviadas || []),
								action.payload
							]
						}
					};
				}
				return dceg;
			});
			const newState = {
				...state,
				desafios_cursos_estudiantes_grupos: updatedGrupos
			};
			return newState;
		}
	}
});

export const {
	setCurrentDesafioSelectedEstudiante,
	updateCurrentDesafioSelectedEstudiante,
	resetCurrentDesafioSelectedEstudiante,
	addGuiaEnviada,
	addGuiaEnviadaGrupo,
	addInstrumentoEnviadoIndividual,
	addInstrumentoEnviadoGrupal
} = currentDesafioSelectedEstudianteSlice.actions;

export default currentDesafioSelectedEstudianteSlice.reducer;
